import { h, FunctionComponent, Fragment } from 'preact'
import { useState } from 'preact/hooks'
import FieldWrapper from '../components/FieldWrapper'
import { FieldCommonProps } from '../type'

import styles from './index.scss'

const DescriptionField: FunctionComponent<FieldCommonProps> = (props) => {
  const { onFieldSubmit } = props
  const [disabled, setDisabled] = useState(false)

  const handleNext = () => {
    setDisabled(true)
    onFieldSubmit?.('')
  }

  return (
    <FieldWrapper {...props} className={styles.wrapper} handlerProps={{ visible: true, disabled, onNext: handleNext }}>
      <></>
    </FieldWrapper>
  )
}

export default DescriptionField
